import React from 'react';
import ServiceDeskAutomationAppBase from '@atlassian/jira-servicedesk-automation-common/src/view/app-base';
import rootEpic from '@atlassian/jira-servicedesk-automation-summary/src/ops';
import rootReducer from '@atlassian/jira-servicedesk-automation-summary/src/state/reducer';
import SummaryView from '@atlassian/jira-servicedesk-automation-summary/src/view';
import type { BaseState } from '@atlassian/jira-servicedesk-common/src/model/types';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';

export type Props = {
	initialState: BaseState;
	baseUrl: string;
};

const SummaryApp = ({ initialState, baseUrl }: Props) => (
	<ServiceDeskAutomationAppBase
		appName={APP_NAMES.AUTOMATION_SUMMARY}
		initialState={initialState}
		rootReducer={rootReducer}
		rootEpic={rootEpic}
		baseUrl={baseUrl}
	>
		<SummaryView />
	</ServiceDeskAutomationAppBase>
);

export default SummaryApp;
